// Records login/logout events through the shared auth-session audit function.
import { supabase } from '@/integrations/supabase/client';

export async function recordAuthSessionActivity(action: 'login' | 'logout'): Promise<void> {
  try {
    const { data } = await supabase.auth.getSession();
    const accessToken = data.session?.access_token?.trim();
    if (!accessToken) {
      return;
    }

    const { error } = await supabase.functions.invoke('log-auth-session', {
      body: {
        action,
      },
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    if (error) {
      console.error('Failed to record auth session activity:', error);
    }
  } catch (error) {
    console.error('Failed to record auth session activity:', error);
  }
}
